import React, { useContext, useEffect, useState } from "react";

import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LogoutModal from "../components/LogoutModal";
import Meta from "../components/Meta";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

import SescServices from "../services/handleSesc";
import ImagemTC from "../assets/credencial_plena.png";
import ImagemPG from "../assets/credencial_atividades.png";
import PerfilCV from "../assets/perfil.png";
import ImagemConv from "../assets/credencial_convenio.png"; // Tipo 4
import ImagemConvDep from "../assets/credencial_convenio.png"; // Tipo 5

import Loader from "../components/Loader";
import { AuthContext } from "../store/AuthContext";
import Barcode from "react-barcode";
import QRCode from "qrcode.react";

const CredencialScreen = () => {
  const { handleLogout, timer } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [clientela, setClientela] = useState("");
  const [matricula, setMatricula] = useState([]);
  const [matriculaVia, setMatriculaVia] = useState("");
  const [vencimento, setVencimento] = useState([]);
  const [via, setVia] = useState("");
  const [foto, setFoto] = useState("");
  const [perfil, setPerfil] = useState("");
  const [categoria, setCategoria] = useState("");
  const [tipoCategoria, setTipoCategoria] = useState("");
  const [tipo, setTipo] = useState("");
  const [dtNascimento, setDtNascimento] = useState([]);
  const [cardVenc, setCardVenc] = useState(false);
  const [sqtitulmat, setSQtitulmat] = useState("");

  const [useQRCode, setUseQRCode] = useState(false); // flag para usar QRCode

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const categoriasPermitidas = [
    36, 37, 11, 43, 59, 60, 7, 86, 88, 91, 78, 48, 19,
  ];

  function hexToBase64(hexstring) {
    return btoa(
      hexstring
        .match(/\w{2}/g)
        .map((a) => String.fromCharCode(parseInt(a, 16)))
        .join("")
    );
  }

  const pesquisa = async () => {
    const resp = await SescServices.helper2(userInfo);

    setSQtitulmat(resp.SQTITULMAT);
    setClientela(resp.NMCLIENTE);
    setVia(resp.NRVIACART);

    const splitsMat = resp.MATFORMAT.split("-");
    setMatricula(splitsMat);
    setMatriculaVia(splitsMat.join("").trim());

    const dtAtual = new Date().toISOString().slice(0, 10);
    if (resp.DTVENCTO < dtAtual) setCardVenc(true);

    setVencimento(resp.DTVENCTO.split("-"));
    setFoto(resp.FOTO2 ? hexToBase64(resp.FOTO2) : "");
    setPerfil(resp.FOTO2 ? "" : PerfilCV);

    setTipo(resp.TPCATEGORI);
    console.log("TIPO DA CREDENCIAL:", resp.TPCATEGORI);
    setDtNascimento(resp.DTNASCIMEN.split("-"));
    setCategoria(resp.DSCATEGORI);
    setTipoCategoria(resp.CDCATEGORI);
  };

  useEffect(() => {
    if (userInfo?.cpf) {
      setLoading(true);
      pesquisa().finally(() => {
        setTimeout(() => setLoading(false), 1000);
      });
    }
  }, []);

  if (timer === 0) handleLogout();
  if (timer < 3)
    return (
      <div>Em {timer} segundos, você será desconectado automaticamente</div>
    );

  // Componente interno para o cartão de credencial
  const CredencialCard = ({ backgroundImage, nacionalidade }) => {
    const codeValue = via + matriculaVia;

    const getImagemCentral = () => {
      // Tipo 2 – Atividades
      if (tipo === 2) {
        return sqtitulmat !== null ? "/img/IMG_PGDEP.png" : "/img/IMG_PG.png";
      }

      // Tipo 4 – Conveniado Titular
      if (tipo === 4) {
        return "/img/IMG_CONV.png";
      }

      // Tipo 5 – Conveniado Dependente
      if (tipo === 5) {
        return "/img/IMG_CONVDEP.png";
      }

      // Demais tipos – Trabalhador do Comércio
      return sqtitulmat !== null ? "/img/IMG_TCDEP.png" : "/img/IMG_TC.png";
    };

    const getBackgroundStyle = (backgroundImage) => {
      let backgroundSize = "auto";
      let backgroundPosition = "top center";

      if (tipo === 4 || tipo === 5) {
        backgroundSize = "cover";
        backgroundPosition = "center top";
      }

      return {
        backgroundImage: `url(${backgroundImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize,
        backgroundPosition,
        width: "390px",
        height: "800px",
        color: "#000000",
      };
    };

    return (
      <div className="row">
        <div className="col-xl-3 col-md-12 mb-4">
          <div style={getBackgroundStyle(backgroundImage)}>
            <p
              className="text-center"
              style={{ paddingTop: tipo === 2 ? "110px" : "105px" }}
            >
              <img
                src={foto ? `data:image/png;base64,${foto}` : perfil}
                className="rounded-circle"
                width="150"
                height="150"
                alt="perfil"
              />
            </p>

            <p className="text-center">
              <strong style={{ fontSize: "14px" }}>{clientela}</strong> <br />
              {`${dtNascimento[2]}/${dtNascimento[1]}/${dtNascimento[0]}`}
            </p>

            <p className="text-center">
              <img
                src={getImagemCentral()}
                width="215"
                height={tipo === 2 ? "93" : "97"}
                alt="identificação"
              />
            </p>

            <p className="text-center">
              {categoriasPermitidas.includes(tipoCategoria) && (
                <p>{categoria}</p>
              )}
              {matricula.join("-")}
              <br />
              {useQRCode ? (
                <QRCode
                  value={codeValue}
                  size={128}
                  bgColor="#ffffff"
                  fgColor="#000000"
                />
              ) : (
                <Barcode
                  value={codeValue}
                  displayValue={true}
                  background={
                    tipo === 2
                      ? "#d1d3d4"
                      : tipo === 4 || tipo === 5
                      ? "#e9e9e9"
                      : "#ffbd00"
                  }
                  fontSize={12}
                  format="CODE128"
                />
              )}
            </p>

            <p className="text-center" style={{ paddingTop: "2px" }}>
              Validade {nacionalidade}: {`${vencimento[1]}/${vencimento[0]}`}{" "}
              <br />
              <strong>Departamento Regional de Alagoas</strong>
            </p>
          </div>
        </div>
      </div>
    );
  };

  // Renderiza o cartão correto baseado no tipo
  const renderCredencial = () => {
    if (cardVenc) return null;

    switch (tipo) {
      case 2:
        return (
          <CredencialCard backgroundImage={ImagemPG} nacionalidade="estadual" />
        );
      case 4:
        return (
          <CredencialCard
            backgroundImage={ImagemConv}
            nacionalidade="nacional"
          />
        );
      case 5:
        return (
          <CredencialCard
            backgroundImage={ImagemConvDep}
            nacionalidade="nacional"
          />
        );
      default:
        return (
          <CredencialCard backgroundImage={ImagemTC} nacionalidade="nacional" />
        );
    }
  };

  return (
    <>
      <ToastContainer />
      <Meta />
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />

            {loading ? (
              <Loader />
            ) : (
              <div className="container-fluid">
                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                  <h1 className="h3 mb-0 text-gray-800">Credencial Virtual</h1>
                </div>

                {renderCredencial()}
              </div>
            )}
          </div>
          <Footer />
        </div>
      </div>
      <LogoutModal />
    </>
  );
};

export default CredencialScreen;
